import { TAvailableTypographyVariants } from "@ob/theme";
import { ThemeOptions } from "@mui/material";
import { typographyVariants } from "../constants";

const variants = Object.keys(
  typographyVariants,
) as unknown as TAvailableTypographyVariants[];

export const muiTypography: ThemeOptions["components"] = {
  MuiTypography: {
    defaultProps: {
      variantMapping: variants.reduce((acc, variant) => {
        const component = typographyVariants[variant].component;
        acc[variant] = component;
        return acc;
      }, {} as Record<TAvailableTypographyVariants, string>),
    },
    variants: variants.map((variant: TAvailableTypographyVariants) => ({
      props: { variant },
      style: ({ theme }) => ({ color: theme.palette.typography[variant] }),
    })),
  },
};
